import { IAbstractModel } from 'model/abstract.model';
import { IEstabelecimento } from 'model/estabelecimento.model';
import { FlowConsignadoListFilterPayloadDTO } from 'pages/consignado/list/consignado-list.model';
import {
    FiltroAvancadoContaReceberDTO,
    StatusContaPagarReceber,
} from 'pages/financas/financas.model';
import { toLocalDateBackEndFriendly } from 'utils/util';

export const buildFiltroContaReceberVencida = (
    cliente: IAbstractModel,
    estabelecimento: IEstabelecimento,
): FiltroAvancadoContaReceberDTO => {
    const ontem = new Date();
    ontem.setDate(ontem.getDate() - 1);

    return {
        descricao: '',
        pessoa: cliente,
        numeroDocumentos: [],
        numeroParcela: '',
        emissao: { inicio: null, fim: null },
        vencimento: { inicio: null, fim: toLocalDateBackEndFriendly(ontem) },
        baixa: { inicio: null, fim: null },
        estabelecimentos: [estabelecimento],
        formasPagamento: [],
        statusParcela: [StatusContaPagarReceber.ABERTA, StatusContaPagarReceber.PARCIAL],
        filtroCartaoDTO: { nsus: [], numerosControle: [] },
        filtroChequeDTO: {
            banco: null,
            agenciaCheque: null,
            numeroCheque: null,
            situacoesCheque: [],
            chequeComTerceiro: null,
        },
        pageNumber: 1,
        pageSize: 1,
    };
};

export const buildFiltroConsignadoEmAndamento = (
    clienteUuid: string,
): FlowConsignadoListFilterPayloadDTO => {
    return {
        cliente: clienteUuid,
    };
};
